import styled from 'styled-components';

export const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    padding: 20px;
`;

export const Card = styled.div`
    background-color: #e0b158; /* e0b158 f5eddc*/
    border: 1px solid #a37a2c; /* Slightly darker border */
    border-radius: 8px;
    padding: 20px;
    transition: transform 0.3s ease;
    cursor: pointer;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    &:hover {
        transform: scale(1.05);
    }
`;

export const CardTitle = styled.h3`
    margin: 0;
    font-size: 1.5rem;
    color: #000; /* Darker blue for title */
`;

export const CardContent = styled.div`
    margin-top: 10px;
    color: #000; /* Black text for content */
    line-height: 1.5;
`;
